export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7341.74a8ec84.jpg";